import React from 'react';
import TextInput from 'components/TextInput/TextInput';
import { chargeTypeEnum } from 'components/CipManagementv2/components/CipThreshold';
import {
  formatCurrency,
  formatPercent,
  unFormatCurrency,
  unFormatPercent
} from 'utils';

interface RangeInputProps {
  label: string;
  type?: any;
  chargeValue: number | null;
  onChange: (value: number | null) => void;
}

const RangeInput = ({
  label,
  type = chargeTypeEnum.PERCENTAGE,
  chargeValue,
  onChange
}: RangeInputProps) => {
  const transformValue = (value: any, format = true) => {
    if (type === chargeTypeEnum.PERCENTAGE)
      return format ? formatPercent(value) : unFormatPercent(value);
    if (type === chargeTypeEnum.MONETARY)
      return format ? formatCurrency(value) : unFormatCurrency(value);
    return value;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e;

    // Check if input is empty and pass null to onChange
    if (!inputValue) {
      onChange(null);
      return;
    }

    // Unformat value based on type
    const parsedValue = transformValue(inputValue, false);

    // Update only if parsed value is a number
    if (!isNaN(parsedValue)) {
      onChange(parsedValue);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '.5rem'
      }}
    >
      <div>{label}</div>
      <TextInput
        label=""
        value={chargeValue !== null ? transformValue(chargeValue) : ''}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default RangeInput;
